// extracted by mini-css-extract-plugin
export default {"disableFunctionalityText":"message-constant_disableFunctionalityText__En7g8","disableFunctionality":"message-constant_disableFunctionality__FQvNB"};